import { observable, action } from 'mobx';

export default class BgCheckOrder {
  @observable programMemberId: number = null;
  @observable firstName: string = null;
  @observable lastName: string = null;
  @observable emails: string[] = [];
  @observable selectedEmail: string = null;
  @observable selectedPackage: string = null;
  @observable billCandidate: boolean = null;

  @observable showOrderModal: boolean = false;
  @observable showSelectEmail: boolean = false;
  @observable showSelectBackgroundCheck: boolean = false;

  @action
  reset() {
    this.programMemberId = null;
    this.firstName = null;
    this.lastName = null;
    this.emails = [];
    this.selectedEmail = null;
    this.selectedPackage = null;
    this.billCandidate = null;

    this.showOrderModal = false;
    this.showSelectEmail = false;
    this.showSelectBackgroundCheck = false;
  }
}
